module.exports = __webpack_public_path__ + "img/ecartapi.bdce1a5c.svg";